// Motor de "Fichaje o No Fichaje". Sin React adentro: se puede simular en Node.
import { FORMATIONS } from '../../helpers/formations';

export { FORMATIONS };

/** Convierte '4-3-3' en los 11 slots, con repetidos: ['GK','RB','CB','CB','LB',...]. */
export function slotsDeFormacion(nombre) {
    const def = FORMATIONS[nombre];
    if (!def) return [];
    const slots = [];
    for (const [pos, cantidad] of Object.entries(def)) {
        for (let i = 0; i < cantidad; i++) slots.push(pos);
    }
    return slots;
}

// Aperturas dentro de UNA ronda. Son 10 maletines: elegís 1 y quedan 9.
// Suman 8, no 9: tiene que sobrevivir un maletín rival hasta el final, si no la última oferta
// se calcula contra tu propio maletín y el Banquero te canta lo que tenés adentro.
export const APERTURAS_RONDA = [4, 2, 2];

// Qué tan cerca del promedio real ofrece el Banquero en cada tanda. Arranca ofreciendo poco.
const FACTOR_OFERTA = [0.45, 0.7, 0.9];

export const TOTAL_RONDAS = 11;

/** Valor que el Banquero está dispuesto a poner sobre la mesa en esta tanda. */
export function valorDeOferta(valoresRestantes, tanda) {
    if (!valoresRestantes.length) return 0;
    const promedio = valoresRestantes.reduce((a, b) => a + b, 0) / valoresRestantes.length;
    return Math.round(promedio * FACTOR_OFERTA[Math.min(tanda, FACTOR_OFERTA.length - 1)]);
}

/**
 * El Banquero ofrece un JUGADOR, no plata: se elige del pool el que más se acerque al valor de
 * la oferta. Nunca repite uno ya ofrecido en la misma ronda.
 */
export function elegirJugadorOferta(pool, valorObjetivo, yaOfrecidos = []) {
    const usados = new Set(yaOfrecidos.map(p => String(p._id)));
    const libres = pool.filter(p => !usados.has(String(p._id)));
    if (!libres.length) return null;
    return libres.reduce((mejor, p) =>
        Math.abs(p.valor - valorObjetivo) < Math.abs(mejor.valor - valorObjetivo) ? p : mejor
    );
}

/** Mood para las frases del personaje, reutilizando los del Modo 412. */
export function humorBanquero(valorOferta, valoresRestantes) {
    if (!valoresRestantes.length) return 'normal';
    const max = Math.max(...valoresRestantes);
    const ratio = valorOferta / max;
    if (ratio < 0.2) return 'risa';
    if (ratio < 0.5) return 'pensando';
    if (ratio < 0.8) return 'apurado';
    return 'enojo';
}

/** Slots libres donde este jugador puede entrar. */
export function slotsPosiblesPara(jugador, slotsLibres) {
    const puede = new Set(jugador.posiciones || []);
    return [...new Set(slotsLibres.filter(s => puede.has(s)))];
}

export function mezclar(arr) {
    const c = [...arr];
    for (let i = c.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [c[i], c[j]] = [c[j], c[i]];
    }
    return c;
}

// ── Torneo ──────────────────────────────────────────────────────────────────
// Los rivales quedan para más adelante (la idea es que sean equipos históricos), así que por
// ahora son de relleno: una fuerza que crece ronda a ronda para que la copa sea cada vez
// más difícil. Lo único real es la fuerza de TU equipo.

export const RONDAS_TORNEO = [
    { nombre: 'Dieciseisavos', fuerzaRival: 450 },
    { nombre: 'Octavos', fuerzaRival: 650 },
    { nombre: 'Cuartos', fuerzaRival: 850 },
    { nombre: 'Semifinal', fuerzaRival: 1050 },
    { nombre: 'Final', fuerzaRival: 1300 },
];

/** Fuerza del equipo: suma de cotizaciones en millones. */
export function fuerzaEquipo(plantel) {
    return Math.round(Object.values(plantel).reduce((s, j) => s + (j ? j.valor : 0), 0) / 1_000_000);
}

/**
 * Un partido. La probabilidad de ganar sale de la fuerza relativa, con un piso y un techo para
 * que ni el mejor equipo tenga la copa asegurada ni el peor quede sin chances.
 */
export function jugarPartido(fuerzaPropia, fuerzaRival, azar = Math.random) {
    const p = Math.min(0.9, Math.max(0.1, fuerzaPropia / (fuerzaPropia + fuerzaRival)));
    const gana = azar() < p;
    const dif = Math.round(Math.abs(p - 0.5) * 6);
    const golesGanador = 1 + Math.floor(azar() * 2) + Math.max(0, dif);
    const golesPerdedor = Math.floor(azar() * Math.max(1, golesGanador - 1));
    return {
        gana,
        marcador: gana ? [golesGanador, golesPerdedor] : [golesPerdedor, golesGanador],
        probabilidad: p,
    };
}

/** Corre la copa entera y devuelve el detalle ronda por ronda. */
export function jugarTorneo(plantel, azar = Math.random) {
    const fuerza = fuerzaEquipo(plantel);
    const partidos = [];
    for (const ronda of RONDAS_TORNEO) {
        const r = jugarPartido(fuerza, ronda.fuerzaRival, azar);
        partidos.push({ ...ronda, ...r });
        if (!r.gana) return { fuerza, partidos, campeon: false, eliminadoEn: ronda.nombre };
    }
    return { fuerza, partidos, campeon: true, eliminadoEn: null };
}

// ── Ubicación en la cancha ──────────────────────────────────────────────────
// Cada puesto cae en una línea (top %) y dentro de la línea se reparte a lo ancho. Es el mismo
// criterio de bandas que usa Build11, adaptado a que acá los slots vienen de la formación.

const LINEA = { GK: 90, LB: 72, CB: 72, RB: 72, CDM: 58, LM: 46, CM: 46, RM: 46, CAM: 34, LW: 16, ST: 16, RW: 16 };
// Orden dentro de la línea: los izquierdos a la izquierda, los derechos a la derecha.
const LADO = { LB: 0, LM: 0, LW: 0, CB: 1, CDM: 1, CM: 1, CAM: 1, ST: 1, RB: 2, RM: 2, RW: 2 };

/** Devuelve [{ slot, indice, top, left }] con la posición de cada puesto en la cancha, en %. */
export function layoutFormacion(slots) {
    const porLinea = new Map();
    slots.forEach((slot, indice) => {
        const top = LINEA[slot] ?? 50;
        if (!porLinea.has(top)) porLinea.set(top, []);
        porLinea.get(top).push({ slot, indice });
    });

    const salida = [];
    for (const [top, fila] of porLinea) {
        fila.sort((a, b) => (LADO[a.slot] ?? 1) - (LADO[b.slot] ?? 1) || a.indice - b.indice);
        fila.forEach((x, k) => {
            salida.push({ ...x, top, left: ((k + 1) / (fila.length + 1)) * 100 });
        });
    }
    return salida;
}

/**
 * Al abrir un maletín: ¿salió uno de los caros o de los baratos?
 * Se compara contra la mediana de los que seguían en juego ANTES de abrirlo. Abrir uno caro es
 * malo (se fue una bomba) y uno barato es bueno, igual que en el programa.
 */
export function calorDeApertura(valorAbierto, valoresAntes) {
    if (valoresAntes.length < 2) return null;
    const orden = [...valoresAntes].sort((a, b) => a - b);
    const mediana = orden[Math.floor(orden.length / 2)];
    return valorAbierto >= mediana ? 'caro' : 'barato';
}
